import { render, staticRenderFns } from "./PropertyTypePill.vue?vue&type=template&id=0fa23fe4"
import script from "./PropertyTypePill.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTypePill.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports